var r=!0;function n(n,o){if(!r){if(n)return;var e="Warning: "+o;"undefined"!=typeof console&&console.warn(e);try{throw Error(e)}catch(r){}}}export{n as default};
//# sourceMappingURL=tiny-warning.esm.js.map
